/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

// Style
import style from "./navbar.module.scss";

// Component
import NavMobileMode from "./mobileMode";
export default function Navbar() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  // Function
  const getNavItemClass = (path: string) => {
    return window.location.pathname === path
      ? `${style.nav_distance} font-vietnam-400 ${style.border_bottom_active}`
      : `${style.nav_distance} font-vietnam-400`;
  };

  return (
    <nav
      className={`navbar bg-white-8 navbar-expand-lg navbar-light py-2 mb-5 ${style.border_bottom_navbar}`}
    >
      <a className="navbar-brand font-federicka font-size-30" href="/">
        Bale's
      </a>

      {/* Desktop Menu */}
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav mb-2 mx-auto mb-lg-0">
          <li className={`nav-item ${getNavItemClass("/")} font-vietnam-400`}>
            <a className="nav-link active" aria-current="page" href="/">
              Home
            </a>
          </li>
          <li
            className={`nav-item ${getNavItemClass("/about")} font-vietnam-400`}
          >
            <a className="nav-link" href="/about" rel="noreferrer">
              About
            </a>
          </li>
          <li
            className={`nav-item ${getNavItemClass(
              "/services"
            )} font-vietnam-400`}
          >
            <a className="nav-link" href="/services">
              Services
            </a>
          </li>
          <li
            className={`nav-item ${getNavItemClass(
              "/history-job"
            )} font-vietnam-400`}
          >
            <a className="nav-link" href="/history-job">
              Journey
            </a>
          </li>
          <li
            className={`nav-item ${getNavItemClass(
              "/contact"
            )} font-vietnam-400`}
          >
            <a className="nav-link" href="/contact">
              Contact
            </a>
          </li>
        </ul>
      </div>

      {/* mobile mode */}
      {isMobile && <NavMobileMode />}
    </nav>
  );
}
